import { type FC } from 'react';
import badgeComplete from 'images/progress_badge_complete.png';
import badgeCompleteTurquoise from 'images/progress_badge_complete_turquoise.png';
import badgeInProgress from 'images/progress_badge_in_progress.png';
import badgeInProgressAssessment from 'images/progress_badge_in_progress_assessment.png';
import badgeIncomplete from 'images/progress_badge_incomplete.png';
import lockBeige from 'vectors/lock_beige.svg';

/*
    The hexagonal progress badge. Locked wins over every other state.
*/

type Props = {
    isAssessmentOrTest: boolean;
    isInProgress: boolean;
    isComplete: boolean;
    isLocked: boolean;
    className?: string;
};

export const LessonProgressIcon: FC<Props> = ({
    isAssessmentOrTest,
    isInProgress,
    isComplete,
    isLocked,
    className,
}) => {
    const { src, width, height } = getBadge({ isAssessmentOrTest, isInProgress, isComplete, isLocked });

    return <img src={src} width={width} height={height} alt="" className={className} />;
};

function getBadge({ isAssessmentOrTest, isInProgress, isComplete, isLocked }: Omit<Props, 'className'>): {
    src: string;
    width: number;
    height: number;
} {
    if (isLocked) return { src: lockBeige, width: 50, height: 58 };
    if (isComplete) {
        return {
            src: isAssessmentOrTest ? badgeCompleteTurquoise : badgeComplete,
            width: 60,
            height: 61,
        };
    }
    if (isInProgress) {
        return {
            src: isAssessmentOrTest ? badgeInProgressAssessment : badgeInProgress,
            width: 60,
            height: 61,
        };
    }
    return { src: badgeIncomplete, width: 60, height: 61 };
}
